export default __webpack_public_path__ + "static/media/neo-logo-lettering.d769dd01.png";